import { GrowthProgress } from "../enums/GrowthProgress.enum";
import { Pot } from "../interfaces/Pot.interface";

export const getPotRows = (pot: Pot): GrowthProgress[][] => {
  const potRows = Object.values(pot.rows).map((row) => {
    return Object.values(row).map((col) => col[0].progress);
  });
  return potRows;
};
